import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:px-4" }
const _hoisted_2 = { class: "mt-0" }
const _hoisted_3 = { class: "mt-3" }
const _hoisted_4 = { class: "mt-3" }

export function render(_ctx, _cache) {
  const _component_PopupMainNavbar = _resolveComponent("PopupMainNavbar")
  const _component_Password = _resolveComponent("Password")
  const _component_IftaLabel = _resolveComponent("IftaLabel")
  const _component_Message = _resolveComponent("Message")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PopupMainNavbar),
    _createElementVNode("div", _hoisted_1, [
      _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "text-xl text-amber-100 text-start font-extrabold my-3" }, "เปลี่ยนรหัสผ่าน", -1 /* HOISTED */)),
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers((...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_IftaLabel, null, {
            default: _withCtx(() => [
              _createVNode(_component_Password, {
                id: "old-password",
                modelValue: _ctx.form.oldPassword.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.form.oldPassword.value) = $event)),
                onKeyup: _ctx.checkPassword,
                class: "w-full",
                "input-class": "w-full",
                invalid: _ctx.form.oldPassword.invalid,
                feedback: false,
                toggleMask: ""
              }, null, 8 /* PROPS */, ["modelValue", "onKeyup", "invalid"]),
              _cache[4] || (_cache[4] = _createElementVNode("label", { for: "old-password" }, "รหัสผ่านเก่า", -1 /* HOISTED */))
            ]),
            _: 1 /* STABLE */,
            __: [4]
          }),
          (_ctx.form.oldPassword.invalid)
            ? (_openBlock(), _createBlock(_component_Message, {
                key: 0,
                severity: "error",
                variant: "simple",
                pt: {text: 'text-[10px]!'}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.form.oldPassword.msgErr), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_IftaLabel, null, {
            default: _withCtx(() => [
              _createVNode(_component_Password, {
                id: "new-password",
                modelValue: _ctx.form.newPassword.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.form.newPassword.value) = $event)),
                class: "w-full",
                "input-class": "w-full",
                invalid: _ctx.form.newPassword.invalid,
                feedback: false,
                toggleMask: ""
              }, null, 8 /* PROPS */, ["modelValue", "invalid"]),
              _cache[5] || (_cache[5] = _createElementVNode("label", { for: "new-password" }, "รหัสผ่านใหม่", -1 /* HOISTED */))
            ]),
            _: 1 /* STABLE */,
            __: [5]
          }),
          (_ctx.form.newPassword.invalid)
            ? (_openBlock(), _createBlock(_component_Message, {
                key: 0,
                severity: "error",
                variant: "simple",
                pt: {text: 'text-[10px]!'}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.form.newPassword.msgErr), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_IftaLabel, null, {
            default: _withCtx(() => [
              _createVNode(_component_Password, {
                id: "confirm-password",
                modelValue: _ctx.form.confirmPassword.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.form.confirmPassword.value) = $event)),
                class: "w-full",
                "input-class": "w-full",
                invalid: _ctx.form.confirmPassword.invalid,
                feedback: false,
                toggleMask: ""
              }, null, 8 /* PROPS */, ["modelValue", "invalid"]),
              _cache[6] || (_cache[6] = _createElementVNode("label", { for: "confirm-password" }, "ยืนยันรหัสผ่านใหม่", -1 /* HOISTED */))
            ]),
            _: 1 /* STABLE */,
            __: [6]
          }),
          (_ctx.form.confirmPassword.invalid)
            ? (_openBlock(), _createBlock(_component_Message, {
                key: 0,
                severity: "error",
                variant: "simple",
                pt: {text: 'text-[10px]!'}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.form.confirmPassword.msgErr), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ]),
        _createVNode(_component_Button, {
          label: "ยืนยัน",
          type: "submit",
          class: "w-full mt-5",
          loading: _ctx.form.btn.loading,
          disabled: _ctx.form.btn.disabled
        }, null, 8 /* PROPS */, ["loading", "disabled"])
      ], 32 /* NEED_HYDRATION */)
    ])
  ]))
}